import {
	ButtonSubmit,
	ColourStateSolid,
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	DatePickerRangeControl,
	FlexGap,
	FormWrapperLabel,
	Modal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { Controller, FieldValues, FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';
import { useSearchParams } from 'react-router';
import { useSite } from '../../../../_Global/Providers/SiteInterfaceProvider';
import { SearchMessageCentreModalType } from '../../../Types/MessageCentreSearchTypes';
import { MessageArchived, MessageAttachments, MessageRead } from '../Data/SearchMessageCentreFormData';

function SearchMessageCentreModal(props: SearchMessageCentreModalType) {
	const formMethods = useForm();

	const { t } = useTranslation();
	const { currentLocale } = useSite();
	const { control } = formMethods;

	const [urlSearchParams] = useSearchParams();

	const HandleSubmit = (e: FieldValues) => {
		const newUrlParams: any = {};

		Object.keys(e).forEach((key) => {
			if (e[key] !== '' && e[key] !== undefined && e[key] !== null) {
				newUrlParams[key] = e[key];
			}
		});

		props.updateFilterValuesCallback(newUrlParams);
		props.closeCallback();
	};

	return (
		<Modal title={t('messageCentre.filter.title')} isOpen={props.isOpen} closeCallback={props.closeCallback}>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(HandleSubmit)}>
					<fieldset>
						<StackVertical gap={FlexGap.Medium}>
							<div className='row'>
								<div className='col-xs-12 col-md-6'>
									<StackVertical gap={FlexGap.Medium}>
										<Controller
											name='searchTerm'
											control={control}
											render={({ field, fieldState }) => (
												<FormWrapperLabel
													label={t('messageCentre.filter.labels.term')}
													invalid={fieldState.invalid}
													validationMessage={fieldState.error?.message}
												>
													<input
														type='text'
														onChange={(e: any) => {
															field.onChange(e.currentTarget?.value);
														}}
														defaultValue={
															urlSearchParams.get('searchTerm')
																? (urlSearchParams.get('searchTerm') as string)
																: ''
														}
													/>
												</FormWrapperLabel>
											)}
										/>

										<Controller
											name='read'
											control={control}
											render={({ field, fieldState }) => (
												<FormWrapperLabel
													label={t('messageCentre.filter.labels.readStatus')}
													invalid={fieldState.invalid}
													validationMessage={fieldState.error?.message}
												>
													<ComboBoxControl
														name='read'
														placeholder={t('messageCentre.filter.controls.readPlaceholder')}
														data={MessageRead}
														defaultValue={
															urlSearchParams.get('read') !== undefined
																? [urlSearchParams.get('read')]
																: undefined
														}
														forwardValueCallback={(e) => {
															field.onChange(e);
														}}
														displayType={ComboBoxTypeEnum.Single}
														displayItemLabelType={ComboBoxItemDisplayEnum.Label}
														valueType='boolean'
													/>
												</FormWrapperLabel>
											)}
										/>

										<Controller
											name='archived'
											control={control}
											render={({ field, fieldState }) => (
												<FormWrapperLabel
													label={t('messageCentre.filter.labels.archived')}
													invalid={fieldState.invalid}
													validationMessage={fieldState.error?.message}
												>
													<ComboBoxControl
														name='archived'
														placeholder={t(
															'messageCentre.filter.controls.archivedPlaceholder',
														)}
														data={MessageArchived}
														defaultValue={
															urlSearchParams.get('archived') !== undefined
																? [urlSearchParams.get('archived')]
																: undefined
														}
														forwardValueCallback={(e) => {
															field.onChange(e);
														}}
														displayType={ComboBoxTypeEnum.Single}
														displayItemLabelType={ComboBoxItemDisplayEnum.Label}
														valueType='boolean'
													/>
												</FormWrapperLabel>
											)}
										/>
									</StackVertical>
								</div>
								<div className='col-xs-12 col-md-6'>
									<StackVertical gap={FlexGap.Medium}>
										<Controller
											name='dateRange'
											control={control}
											render={({ field, fieldState }) => (
												<FormWrapperLabel
													label={t('messageCentre.filter.labels.dateRange')}
													invalid={fieldState.invalid}
													validationMessage={fieldState.error?.message}
												>
													<DatePickerRangeControl
														name='dateRange'
														forwardValueCallback={(e) => {
															const startDate = e?.from
																? e.from
																		.toLocaleString(currentLocale.code)
																		.split(',')[0]
																		.split('/')
																		.reverse()
																		.toString()
																		.replace(/,/g, '-')
																: undefined;
															const endDate = e?.to
																? e.to
																		.toLocaleString(currentLocale.code)
																		.split(',')[0]
																		.split('/')
																		.reverse()
																		.toString()
																		.replace(/,/g, '-')
																: undefined;

															formMethods.setValue('startDate', startDate);
															formMethods.setValue('endDate', endDate);
														}}
														defaultDateRange={{
															from: urlSearchParams.get('startDate')
																? new Date(urlSearchParams.get('startDate') as string)
																: undefined,
															to: urlSearchParams.get('endDate')
																? new Date(urlSearchParams.get('endDate') as string)
																: undefined,
														}}
													/>
												</FormWrapperLabel>
											)}
										/>

										<Controller
											name='hasAttachment'
											control={control}
											render={({ field, fieldState }) => (
												<FormWrapperLabel
													label={t('messageCentre.filter.labels.attachments')}
													invalid={fieldState.invalid}
													validationMessage={fieldState.error?.message}
												>
													<ComboBoxControl
														name='hasAttachment'
														placeholder={t(
															'messageCentre.filter.controls.attachmentsPlaceholder',
														)}
														data={MessageAttachments}
														defaultValue={
															urlSearchParams.get('hasAttachment') !== undefined
																? [urlSearchParams.get('hasAttachment')]
																: undefined
														}
														forwardValueCallback={(e) => {
															field.onChange(e);
														}}
														displayType={ComboBoxTypeEnum.Single}
														displayItemLabelType={ComboBoxItemDisplayEnum.Label}
														valueType='boolean'
													/>
												</FormWrapperLabel>
											)}
										/>
									</StackVertical>
								</div>
							</div>

							<ButtonSubmit
								fullWidth
								colour={ColourStateSolid.Primary}
								title={t('messageCentre.filter.actions.save')}
							/>
						</StackVertical>
					</fieldset>
				</form>
			</FormProvider>
		</Modal>
	);
}

export { SearchMessageCentreModal };
